"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.loadBillingPlan = loadBillingPlan;
exports.saveBillingPlan = saveBillingPlan;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _budgetBillingPlanApi = require("../api/budgetBillingPlanApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable @typescript-eslint/no-unused-vars */ // import { getBudgetBillingPlan, saveNewBudgetBillingPlan } from '../api/budgetBillingPlanApi';
// Actions
var LOAD_BILLING_PLAN = 'api/reducer/GET_BILLING_PLAN';
var SAVE_BILLING_PLAN = 'api/reducer/SAVE_BILLING_PLAN';

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LOAD_BILLING_PLAN:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData
      });
    case SAVE_BILLING_PLAN:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData
      });
    default:
      return state;
  }
}

// Action Creators
function loadBillingPlan(dispatch, contractId) {
  var resp = (0, _budgetBillingPlanApi.getBudgetBillingPlan)(contractId);
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_BILLING_PLAN,
      data: {
        innerData: reponse.data.content
      }
    });
  });
}
function saveBillingPlan(dispatch, contractId, billPlanItemId, billingItemData) {
  var resp = (0, _budgetBillingPlanApi.saveNewBudgetBillingPlan)(contractId, billPlanItemId, billingItemData);
  return resp.then(function (response) {
    dispatch({
      type: SAVE_BILLING_PLAN,
      data: {
        innerData: response
      }
    });
  });
}